import CustomPermissionModal from '../custom-permission-modal/custom-permission-modal';
import UserClientsModal from '../user-modal/user-modal'
import UserComponent from './user-component'
import UserService from './user-service';

/***
 * A single user row on the User Admin page.
 */
const user = angular
    .module('FacilityData.UserAdmin.User', [
        CustomPermissionModal,
        UserClientsModal
    ])
    .component('user', UserComponent)
    .service('UserService', UserService)
    .name;

export default user;


// WEBPACK FOOTER //
// ./app/components/user-admin/user/user.js